import { render, staticRenderFns } from "./CenterInfo.vue?vue&type=template&id=e2f206b8&scoped=true"
import script from "./CenterInfo.vue?vue&type=script&lang=js"
export * from "./CenterInfo.vue?vue&type=script&lang=js"
import style0 from "./CenterInfo.vue?vue&type=style&index=0&id=e2f206b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f206b8",
  null
  
)

export default component.exports